import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { menuUrl } from "../site-settings-list/model/site-settings-list.constants";
import { createSiteSettings } from "./site-settings-create.component.service";
import { getSiteSettingsInputs } from "../model/site-settings.modal";
import SiteSettingsCreateTemplateComponent from "./site-settings-create-template.component";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  SITE_SETTINGS_ALERTS: { CREATE_ALERT },
} = MESSAGES;

const SiteSettingsCreateComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct payload
    let siteSettingsPayload = {};
    for (let i = 0; i < values.length; i++) {
      siteSettingsPayload[values[i].name] = values[i].value;
    }

    // INFO : call create api
    const siteSettingsResponse = await createSiteSettings(siteSettingsPayload);

    // INFO : check api response and show relevant alert message
    if (siteSettingsResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: CREATE_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: siteSettingsResponse.message })
      );
    }
  };

  const templateModal = {
    formTriggers,
    formInputs: getSiteSettingsInputs({}),
  };

  const templateEvents = {
    handleSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <SiteSettingsCreateTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default SiteSettingsCreateComponent;
